import { VideoObject } from 'schema-dts';
import { Video } from '../../client/types';

export function getVideoStructuredData(video: Video): VideoObject {
  return {
    '@type': 'VideoObject',
    name: video.title,
    description: video.description,
    thumbnailUrl: [
      video.thumbnail,
    ],
    uploadDate: video.uploadDate,
    duration: video.duration,
    contentUrl: video.contentUrl,
    embedUrl: video.embedUrl,
  };
}
